import { DatePicker, Form, Input, InputNumber, Select } from "antd";
import TextArea from "antd/es/input/TextArea";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

export default function InternshipForm({ schools, onSubmit, form }) {
  const { t } = useTranslation();
  const { loading } = useSelector((state) => state?.internships);

  return (
    <Form
      layout="vertical"
      name="internship"
      id="internship_form"
      form={form}
      onFinish={onSubmit}
      disabled={loading}
      style={{
        maxWidth: 600,
        margin: "0 auto",
      }}
    >
      <Form.Item
        label={t("internships.form.school")}
        name="schoolId"
        rules={[
          {
            required: true,
            message: t("internships.form.error.school"),
          },
        ]}
      >
        <Select>
          {schools?.map((school) => (
            <Select.Option key={school?._id} value={school?._id}>
              {school?.name}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item
        label={t("internships.form.title")}
        name="titled"
        rules={[
          {
            required: true,
            message: t("internships.form.error.title"),
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label={t("internships.form.startDate")}
        name="startingDate"
        rules={[
          {
            required: true,
            message: t("internships.form.error.startDate"),
          },
        ]}
      >
        <DatePicker style={{ width: "100%" }} />
      </Form.Item>
      <Form.Item
        label={t("internships.form.paid")}
        name="paid"
        rules={[
          {
            required: true,
            message: t("internships.form.error.paid"),
          },
        ]}
      >
        <Select>
          <Select.Option value={true}>{t("common.yes")}</Select.Option>
          <Select.Option value={false}>{t("common.no")}</Select.Option>
        </Select>
      </Form.Item>
      <Form.Item
        label={t("internships.form.description")}
        name="description"
        rules={[
          {
            required: true,
            message: t("internships.form.error.description"),
          },
        ]}
      >
        <TextArea />
      </Form.Item>
      <Form.Item
        label={t("internships.form.desiredInterns")}
        name="desiredNumberOfMembers"
        rules={[
          {
            required: true,
            message: t("internships.form.error.desiredInterns"),
          },
        ]}
      >
        <InputNumber min={1} />
      </Form.Item>
      <Form.Item
        label={t("internships.form.type")}
        name="stageType"
        rules={[
          {
            required: true,
            message: t("internships.form.error.type"),
          },
        ]}
      >
        <Select>
          <Select.Option value="On The Site">
            {t("internships.type.onSite")}
          </Select.Option>
          <Select.Option value="Hybrid">
            {t("internships.type.hybrid")}
          </Select.Option>
          <Select.Option value="Remote">
            {t("internships.type.remote")}
          </Select.Option>
        </Select>
      </Form.Item>
    </Form>
  );
}
